import Axios from 'axios'
import Servers from "../../server"
export default{
    state: {
      residentObjet: [],
      edit: false,
    },
    mutations: {
      setResident(state, obj){
        state.residentObjet = obj;
      },
      setEditResident(state, obj){
        state.edit = obj;
      }
    },
    getters: {
      getResidentValue(state){
        return state.residentObjet
      },
      getEditResident(state){
        return state.edit
      },
    },
    actions: {
      getAllResidents( _, params){
       return Axios.get(`${Servers.serverApi}api/residents/?page=${params.page}&size=${params.size}&search=${params.search}&useApp=${params.useApp}`, {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        })

      },
      getAllResidentsBrief(){
       return Axios.get(`${Servers.serverApi}api/residents/all/brief`, {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        })
      },
      async createResident(context,data){
       let response = await Axios.post(Servers.serverApi + "api/residents", data, {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        });

          return response
      },
      async editResident(context, data){
      let response = await Axios.put(Servers.serverApi + "api/residents/" + data.uuid, data.body, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      });
      return response;

      },
      async enableResident(context, uuid){
        return await Axios.put(Servers.serverApi + "api/residents/enable/"+uuid, {}, {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        });

      },
      async disableResident(context, uuid){
       return await Axios.put(Servers.serverApi + "api/residents/disable/"+uuid, {}, {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        });
      },
      async resendRegistrationEmail(context, uuid){
        return await Axios.put(Servers.serverApi + "api/residents/resendRegistrationEmail/"+ uuid, {}, {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        });
      }
    }
}